import Vue from 'vue';
import playerService from './player.service';
import currencyService from './currency.service';
import noty from './noty.service';

export default {
  async create(balance) {
    const result = (await Vue.http.post('/api/balance/create', balance)).data;
    noty.success("Balance created successfully");
    return result;
  },
  async depositUser(balanceId, amount, currency) {
    await Vue.http.post('/api/balance/deposituser', { amount: amount, balanceId: balanceId });
    await playerService.load();
    let val = currencyService.fromSource(amount, currency);
    noty.success(`Player successfully deposited for ${val}`);
  },
  async withdrawUser(balanceId, amount, currency) {
    await Vue.http.post('/api/balance/withdrawuser', { amount: amount, balanceId: balanceId });
    await playerService.load();
    let val = currencyService.fromSource(amount, currency);
    noty.success(`Player successfully withdrawn for ${val}`);
  },
  async save(balance) {
    await Vue.http.post('/api/balance/save', balance);
    noty.success(`Balance ${balance.branch} saved successfully`);
  },
  async getWithdrawalRequestsAsync() {
    return (await Vue.http.get("/api/balance/withdrawal/approval/requests")).data;
  },
  async approveRequestedWithdrawalAsync(options) {
    const result = (await Vue.http.post(`/api/balance/${options.balanceId}/withdrawal/approval/request/approve`, options)).data;
    result.isSuccess ? noty.success("Approved successfully") : noty.error("Error occurred during approving");
    return result;
  },
  async declineRequestedWithdrawalAsync(options) {
    const result = (await Vue.http.post(`/api/balance/${options.balanceId}/withdrawal/approval/request/decline`, options)).data;
    result.isSuccess ? noty.success("Declined successfully") : noty.error("Error occurred during declining");
    return result;
  },
  async getMbkLockedBalances() {
    return (await Vue.http.get('/api/balance/mbklocked')).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/balance.service.js